import { forwardRef } from 'react';
import { Select } from '@zoopla-eng/zds-components/select';

import { UserAboutMe } from '../../../graphql.generated';

interface UserAboutMeOption {
    id: UserAboutMe;
    text: string;
}

const emptyOption = { id: '', text: 'Select an option' };

// we use an array here to make sure we keep the order
export const optionsText: [UserAboutMe, string][] = [
    [UserAboutMe.FirstTimeBuyer, 'I am a first-time buyer'],
    [UserAboutMe.BuyerNotFirstTime, 'I am a buyer (not first-time)'],
    [UserAboutMe.PropertyToSell, 'I have a property to sell'],
    [UserAboutMe.PropertyToLet, 'I have a property to let'],
    [UserAboutMe.OfferOnOwnProperty, 'I have an offer on my property'],
    [UserAboutMe.RecentlySold, 'I have recently sold'],
    [UserAboutMe.LookingToInvest, 'I am an investor/hoping to invest'],
    [UserAboutMe.LookingToRent, 'I am looking to rent'],
    [UserAboutMe.CuriousHavingALook, 'I am interested in property'],
    [UserAboutMe.Agent, 'I am an agent']
];

export type AboutYouOption = UserAboutMeOption | typeof emptyOption;

const options: AboutYouOption[] = [
    emptyOption,
    ...optionsText.map(([key, val]) => ({ id: key, text: val })),
    { id: UserAboutMe.Other, text: 'Other' }
];

interface AboutYouProps {
    label: string;
    value: AboutYouOption | undefined;
    onChange: (option: AboutYouOption) => void;
}

export const AboutYou = forwardRef<HTMLButtonElement, AboutYouProps>(
    ({ label, value, onChange }, ref) => {
        return (
            <Select
                label={label}
                data-testid="situation-dropdown"
                options={options}
                selectedOption={value || options[0]}
                onSelectedOptionChange={onChange}
                ref={ref}
            />
        );
    }
);
